import { AspenTasksService, TaskChainDTO } from '../client'
import { useTaskWorkflow } from './useTaskWorkflow'

export const useGreenlightPatientWorkflow = (patientId: string) => {
    // The endpoint returns null when the study/site gate is disabled (no task).
    return useTaskWorkflow<TaskChainDTO | null>(
        patientId,
        AspenTasksService.createGreenlightPatientWorkflowTasksCreateGreenlightPatientWorkflowPatientIdGet
    )
}
